import { useSession as useBetterAuthSession } from "../../../lib/auth";

export function useSession() {
  return useBetterAuthSession();
}
